/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerFindOneQueryResponse, TasksControllerFindOnePathParams, TasksControllerFindOneQueryParams, TasksControllerFindOne400, TasksControllerFindOne401, TasksControllerFindOne403, TasksControllerFindOne404 } from "../../models/tasksController/TasksControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { tasksControllerFindOne } from "../../clients/tasksService/tasksControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const tasksControllerFindOneQueryKey = (id: TasksControllerFindOnePathParams["id"], params: TasksControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/tasks/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TasksControllerFindOneQueryKey = ReturnType<typeof tasksControllerFindOneQueryKey>;
export function tasksControllerFindOneQueryOptions(id: TasksControllerFindOnePathParams["id"], params?: TasksControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = tasksControllerFindOneQueryKey(id, params);
  return queryOptions<TasksControllerFindOneQueryResponse, ResponseErrorConfig<TasksControllerFindOne400 | TasksControllerFindOne401 | TasksControllerFindOne403 | TasksControllerFindOne404>, TasksControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return tasksControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a task by id
 * {@link /api/v1/tasks/:id}
 */
export function useTasksControllerFindOne<TData = TasksControllerFindOneQueryResponse, TQueryData = TasksControllerFindOneQueryResponse, TQueryKey extends QueryKey = TasksControllerFindOneQueryKey>(id: TasksControllerFindOnePathParams["id"], params?: TasksControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TasksControllerFindOneQueryResponse, ResponseErrorConfig<TasksControllerFindOne400 | TasksControllerFindOne401 | TasksControllerFindOne403 | TasksControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? tasksControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...tasksControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TasksControllerFindOne400 | TasksControllerFindOne401 | TasksControllerFindOne403 | TasksControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}